
import React, { useEffect, useRef, useState } from 'react';

import './OptionMenuDropdown.scss';

export interface OptionMenuOption {
    label: string;
    onClick: () => void;
    addClass?: string;
}

interface OptionMenuDropdownProps {
    icon: string;
    withBackground?: boolean;
    coloring?: 'primary' | 'secondary' | 'tertiary' | 'plain';
    size?: 'standard' | 'small';
    disabled?: boolean;
    options: OptionMenuOption[];
}

function OptionMenuDropdown({ icon, withBackground = false, coloring = 'plain', size = 'standard', disabled, options }: OptionMenuDropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isOpen) return;
        const handleOutsideClick = (e: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [isOpen]);

    const handleOptionClick = (optionOnClick: () => void) => {
        setIsOpen(false);
        optionOnClick();
    };

    const colorClass = coloring !== 'plain' ? coloring : '';
    const bgClass = withBackground ? 'withBackground' : '';
    const sizeClass = size === 'small' ? 'size_small' : 'size_standard';
    const openClass = isOpen ? 'open' : '';

    return (
        <div ref={wrapperRef} className={`__OptionMenuDropdown ${colorClass} ${bgClass} ${sizeClass} ${openClass}`}>
            <button
                className="__menuTrigger"
                onClick={() => setIsOpen(prev => !prev)}
                disabled={disabled}
                type="button"
            >
                <span className="material-icons">{icon}</span>
            </button>
            {isOpen && (
                <div className="__dropdownOverlay">
                    {options.map((opt, i) => (
                        <button
                            key={i}
                            className={`__option${opt.addClass ? ` ${opt.addClass}` : ''}`}
                            type="button"
                            onClick={() => handleOptionClick(opt.onClick)}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default OptionMenuDropdown;
